import Tooltip from "@kea-mod/common/tooltip";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { Exercise } from "../../../types/Exercise";
import type { Schema } from "../../../types/Schema";
import { ApiContext } from "../../../context/KeaAPI/newApi";
import { SchemaTreeGraph } from "../../Schemas/SchemaTree/SchemaTreeLogic";

type Props = {
  activeExercise: Exercise;
  h: Function;
};

export const SchemaField = (props: Props) => {
  const { schemaApi, schemaTreeApi, gradingServiceApi } = useContext(ApiContext);

  const { t } = useTranslation();

  const onChange = (event: any) => {
    props.h(event);
  };

  // control the data loading state and only create the graph if all data is loaded
  const [dataLoaded, setDataLoaded] = useState(false); // Add this line

  useEffect(() => {
    Promise.all([schemaApi.getAll(), schemaTreeApi.getAll(), gradingServiceApi.getAll()]).then(() => {
      setDataLoaded(true); // Update the state here
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Create a graph from the schema and grading services, but only if all data is loaded
  const graph = dataLoaded
    ? new SchemaTreeGraph([...schemaApi.elements, ...gradingServiceApi.elements], schemaTreeApi.elements)
    : new SchemaTreeGraph([], []);
  const rootSchemas = Array.from(graph.roots);

  return (
    <div className="field">
      <label className="label" htmlFor="title">
        {t("schema")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-top"
          content={t("schemaTooltip")}
        ></Tooltip>
      </label>
      <div className="select">
        <select value={props.activeExercise.schemaId} onChange={onChange} id="schema" name="schemaId">
          {props.activeExercise.schemaId !== "" && rootSchemas.length > 0 ? (
            <option value={props.activeExercise.schemaId} hidden disabled>
              {rootSchemas.filter((schema: Schema) => schema.id === parseInt(props.activeExercise.schemaId))[0].name}
            </option>
          ) : (
            <option value="" hidden disabled>
              {t("selectSchema")}
            </option>
          )}
          {rootSchemas.map((option) => (
            <option key={option.id} id={option.id.toString()} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
